function sortRequisitionsNewestFirst(requisitions) {
  return [...(requisitions || [])].sort((a, b) => {
    const aTime = Date.parse(a?.submitted_at) || 0;
    const bTime = Date.parse(b?.submitted_at) || 0;
    return bTime - aTime;
  });
}

export const Reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ALL_TEST_REQUESTS': {
      const testRequests = sortRequisitionsNewestFirst(action.payload);
      return {
        ...state,
        testRequests,
        currentTestRequest: testRequests[0] || null,
        hasLoadedTestRequests: true,
      };
    }

    case 'SET_CURRENT_TEST_REQUEST':
      return {
        ...state,
        currentTestRequest: action.payload,
      };

    case 'SET_KEYCLOAK':
      return {
        ...state,
        keycloak: action.payload,
      };

    case 'SET_REQUEST_INFO':
      return {
        ...state,
        testRequestInfo: action.payload,
      };

    case 'SET_USER_INFO': {
      const userInfoResponse = action.payload;
      const fvtReferralUUID = userInfoResponse.fvt_referral_uuid || null;

      return {
        ...state,
        fvtReferralUUID,
        userInfo: userInfoResponse,
      };
    }

    case 'SET_GC_ACCESS_CODE':
      return {
        ...state,
        gcAccessCode: action.payload,
      };

    case 'SET_STRIPE_PAYMENT_INFO':
      return {
        ...state,
        stripePaymentInfo: action.payload,
      };

    case 'SET_USER_INFO_FETCHING':
      return {
        ...state,
        isFetchingUserInfo: action.payload,
      };

    case 'SET_USER_INFO_LOADED':
      return {
        ...state,
        hasLoadedUserInfo: action.payload,
        ...(action.payload === false ? { hasLoadedTestRequests: false } : {}),
      };

    case 'SET_USER_ID':
      return {
        ...state,
        userId: action.payload,
      };

    case 'SET_GENETIC_COUNSELING_DETAILS':
      return {
        ...state,
        geneticCounselingDetails: action.payload,
      };

    default:
      return state;
  }
};
